import { Step } from "./types";
import { stepBerufFamilie, stepPersoenlich, stepWelcome, stepZiele } from "./part1";
import { stepAltersvorsorge, stepArbeitskraft, stepGesundheit, stepSach } from "./part2";
import {
  stepAusgaben, stepEinkommen, stepGas, stepHaushalt, stepKrankenversicherung, stepStrom, stepVermoegen,
} from "./part3";
import {
  stepBerater, stepDatenschutz, stepDokumente, stepPraeferenzen, stepSonstiges,
  stepZukunft, stepZusammenfassung,
} from "./part4";

/* Reihenfolge der 22 Eingabeschritte (Erfolgsseite folgt separat im Controller). */
export const STEPS: Step[] = [
  stepWelcome,        // 1
  stepZiele,          // 2
  stepPersoenlich,    // 3
  stepBerufFamilie,   // 4
  stepGesundheit,     // 5
  stepAltersvorsorge, // 6
  stepArbeitskraft,   // 7
  stepSach,           // 8
  stepVermoegen,      // 9
  stepStrom,             // 10
  stepGas,               // 11
  stepKrankenversicherung, // 12
  stepEinkommen,         // 13
  stepAusgaben,          // 14
  stepHaushalt,          // 15
  stepZukunft,           // 16
  stepPraeferenzen,      // 17
  stepDokumente,         // 18
  stepSonstiges,         // 19
  stepBerater,           // 20
  stepZusammenfassung,   // 21
  stepDatenschutz,       // 22
];

export function stepIndexById(id: string): number {
  return STEPS.findIndex((s) => s.id === id);
}
